import React from 'react';

import i18n from 'util/i18n';
import { SUBSTANCE_USE_DRUGS_INTRO } from 'config/formSections/substanceUse';

import SectionIntro from 'components/Section/shared/SectionIntro';

const DrugActivityIntro = function () {
  return (
    <SectionIntro
      title={i18n.t('substance.pvq.drugs.intro.title')}
      body={i18n.m('substance.pvq.drugs.intro.body')}
      sectionKey={SUBSTANCE_USE_DRUGS_INTRO.key}
      isSimpleTitle
    />
  );
};

export default DrugActivityIntro;
